const ERROR_MESSAGES: Record<string, string> = {
  VALIDATION_FAILED: 'The request contained invalid data. Please check your input.',
  UNAUTHENTICATED: 'Your session has expired. Please sign in again.',
  MFA_REQUIRED: 'Multi-factor authentication is required.',
  FORBIDDEN_ROLE: 'You do not have permission to perform this action.',
  NOT_FOUND: 'The requested resource could not be found.',
  DUPLICATE_RESOURCE: 'This record already exists.',
  CITATION_VERIFICATION_FAILED: 'One or more citations could not be verified. Review the appeal before submitting.',
  APPEAL_NOT_APPROVABLE: 'This appeal cannot be approved in its current state.',
  RATE_LIMITED: 'Too many requests. Please wait a moment and try again.',
  LLM_UNAVAILABLE: 'The AI service is temporarily unavailable. Please try again shortly.',
  DOWNSTREAM_TIMEOUT: 'A required service timed out. Please try again.',
  UNKNOWN_ERROR: 'An unexpected error occurred. Please try again.',
};

export function friendlyError(code: string): string {
  return ERROR_MESSAGES[code] ?? 'An unexpected error occurred. Please try again.';
}
